.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .form-subtitle-download-links {
      margin-top: calc(var(--spacer) * 0.5);
      text-transform: uppercase;
      color: var(--chart-300-icon-buttons);
    }

    .form-wrapper {
      min-width: 500px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding-left: calc(var(--spacer) * 5);
      padding-top: calc(var(--spacer) * 2);
      padding-right: var(--spacer);

      gz-chips-generator-input {
        --form-field-label-custom-width: calc(var(--form-field-label-width) - 34px);
      }
    }

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--chart-101-pressed-dividers);

      padding-left: calc(var(--spacer) * 4);
      padding-right: calc(var(--spacer) * 4);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }
    }

    .gz-link-config {
      min-width: 53.5em;
      font-size: var(--body-size);
      pointer-events: none;
      cursor: default;
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

.form-section {
  margin-top: calc(var(--spacer) * 2);
  margin-bottom: calc(var(--spacer) * 4);
  flex-direction: column;

  gz-form-field {
    &::part(form-field-label) {
      min-width: 220px;
    }
  }
}

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2);
  margin-bottom: calc(var(--spacer) * 1);
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

.no-display {
  display: none;
}
